import { useState } from "react";
import Footer from "../components/Footer";

const FAQS = [
  { q:"How long does delivery take?", a:"Delivery within Chhatrapati Sambhajinagar takes 3-4 days, rest of Maharashtra 5-7 days, and the rest of India 6-9 days. You can check the exact estimate for your pincode on any product page." },
  { q:"What payment methods do you accept?", a:"We accept UPI, Credit/Debit Cards, and Net Banking — all processed securely through Razorpay. Cash on Delivery is not offered at this time." },
  { q:"Can I return or exchange an item?", a:"Yes — most items can be returned within 7 days of delivery if unused and with tags intact. See our Return & Exchange Policy for full details." },
  { q:"Can I cancel my order?", a:"Yes, as long as your order status still shows \"Confirmed\" (before it's packed). Go to My Orders and tap \"Cancel Order\". Once it's packed or shipped, please contact us on WhatsApp instead." },
  { q:"How do I track my order?", a:"Visit My Orders to see your order's status. You can also tap \"Track\" to message us directly on WhatsApp." },
  { q:"Do you have a size chart?", a:"Yes — every product page has a \"Size Chart\" button with measurements to help you pick the right fit." },
  { q:"Is Cash on Delivery available?", a:"Not currently — all orders are paid online via UPI, Card, or Net Banking at checkout." },
  { q:"How do I use a coupon code?", a:"On the Cart page, enter your coupon code in the \"Enter coupon code\" box and tap Apply. The discount will reflect immediately." },
  { q:"Do you deliver outside Maharashtra?", a:"Yes, we deliver across India. Delivery to other states typically takes 6-9 days." },
  { q:"How can I contact Matchwell directly?", a:"The fastest way is WhatsApp — tap the WhatsApp button on any page, or visit our Contact Us page for our showroom address and hours." },
];

export default function FAQPage({ onNav }) {
  const [open, setOpen] = useState(null);

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"28px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,34px)", fontWeight:900, color:"white" }}>Frequently Asked Questions</h1>
      </div>

      <div style={{ maxWidth:720, margin:"0 auto", padding:"clamp(24px,5vw,44px) clamp(16px,4vw,40px)" }}>
        {FAQS.map((f,i)=>(
          <div key={i} style={{ borderBottom:"1px solid #f0f0f0" }}>
            <button onClick={()=>setOpen(open===i?null:i)} style={{ width:"100%", background:"none", border:"none", padding:"18px 0", display:"flex", justifyContent:"space-between", alignItems:"center", cursor:"pointer", textAlign:"left" }}>
              <span style={{ fontSize:14, fontWeight:700, color:"#1a1a2e" }}>{f.q}</span>
              <span style={{ fontSize:18, color:"#EC4899", transform:open===i?"rotate(45deg)":"none", transition:"transform 0.2s" }}>+</span>
            </button>
            {open===i && <p style={{ fontSize:13, color:"#666", lineHeight:1.8, paddingBottom:18 }}>{f.a}</p>}
          </div>
        ))}

        <div style={{ textAlign:"center", marginTop:32, padding:24, background:"#F0FDF4", borderRadius:16 }}>
          <p style={{ fontSize:13, color:"#16A34A", fontWeight:700, marginBottom:10 }}>Still have a question?</p>
          <button onClick={()=>onNav("contact")} style={{ background:"#25D366", color:"white", border:"none", padding:"11px 26px", borderRadius:50, fontSize:13, fontWeight:700, cursor:"pointer" }}>
            💬 Contact Us
          </button>
        </div>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
